import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("历史回款周期分布图")

import { ref, reactive, onBeforeMount, nextTick, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { formatTime, formatNumber, exportHandle } from '@/utils/index'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'
import * as echarts from "echarts";

export default /*#__PURE__*/_defineComponent({
  props: {
    isAuthorize: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isAuthorize: boolean
}

const {
  'POST/verification/flow_authorize': fetchList,
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 授权
  'POST/verification/flow_authorize/authorize': authorizeApi,
  // 订单饼图
  'POST/verification/flow_authorize/pie': pieApi,
  // 根据英文名搜索销售
  'GET/users/dropdown/alias': dropdownAliasApi,
  // 根据客户名、客户ID模糊搜索
  'GET/verification/accounts/dropdown/search': dropdownSearchApi,
} = Api



let orgList: any = ref([])
onBeforeMount(() => {
  organizationsApi().then((rep) => {
    orgList.value = rep
  })
})

const searchEle = ref()
const parmasObj = reactive({
  orgId: '',
  salesperson: '',
  customerId: '',
  customerName: '',
  authorize: props.isAuthorize
})

let seleRows: any = ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

// 下拉搜索
const salemanOption = ref<ListItem[]>([])
const loading = ref<boolean>(false)
const remoteSalemanSearch = (query: string) => {
  if (query) {
    loading.value = true
    dropdownAliasApi({alias: query}).then((rep: any) => {
      salemanOption.value = rep
    }).finally(() => {
      loading.value = false
    })
  } else {
    salemanOption.value = []
  }
}

const idOptions: any = ref([])
const idLoading = ref<boolean>(false)
const remoteIdSearch = (query: string) => {
  if (query) {
    idLoading.value = true
    dropdownSearchApi({type: 'id', value: query}).then((rep: any) => {
      idOptions.value = rep
    }).finally(() => {
      idLoading.value = false
    })
  } else {
  }
}

const nameOptions: any = ref([])
const nameLoading = ref<boolean>(false)
const remoteNameSearch = (query: string) => {
  if (query) {
    nameLoading.value = true
    dropdownSearchApi({type: 'name', value: query}).then((rep: any) => {
      nameOptions.value = rep
    }).finally(() => {
      nameLoading.value = false
    })
  } else {
  }
}

// 授权
const authorizeHandle = () => {
  if(seleRows.value.length === 0){
    ElMessage.warning('至少选择一条数据')
    return
  }
  ElMessageBox.confirm(
    '是否授权?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    MI_identify.value = true
    return authorizeApi({
      customerIds: seleRows.value.map(e => e.customerId)
    })
  }).then(() => {
    ElMessage.success('授权成功')
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })
}

// 取消授权
const unauthorizeHandle = () => {
  if(seleRows.value.length === 0){
    ElMessage.warning('至少选择一条数据')
    return
  }
  ElMessageBox.confirm(
    '是否取消授权?',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    MI_identify.value = true
    return authorizeApi({
      customerIds: seleRows.value.map(e => e.customerId)
    })
  }).then(() => {
    ElMessage.success('取消授权成功')
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })
}

const cellStyleHandle = ({ row, column, rowIndex, columnIndex }) => {
  if(column.property === 'badAmount' || column.property === 'badNumber'){
    return {
      background: '#ffd6cc'
    }
  }
}

// 展示饼图
const chartOption = {}
const historyChartEle = ref()
const isShowChart = ref<boolean>(false)
const showChart = () => {
  if(seleRows.value.length === 0){
    ElMessage.warning('至少选择一条数据')
    return
  }
  MI_identify.value = true
  pieApi({
    orderIds: seleRows.value.map(e => e.orderIds).flat()
  }).then((pieData: any) => {
    isShowChart.value = true
    let chart1;
    nextTick(() => {
      chart1 = echarts.init(historyChartEle.value);
      chart1.setOption({
        title: [
          {
            text: '从订单创建到订单关闭的时间',
            left: '18%',
            top: '12%',
            textAlign: 'center'
          },
          {
            text: '从订单交付到订单关闭的时间',
            left: '50%',
            top: '12%',
            textAlign: 'center'
          },
          {
            text: ' 从订单首次产生成本到订单关闭的时间',
            left: '80%',
            top: '12%',
            textAlign: 'center'
          }
        ],
        legend: [
          {
            data: [
              {name: "30天内", itemStyle: {color: '#facd91'}},
              {name: "30-40天", itemStyle: {color: '#f59a23'}},
              {name: "40-50天", itemStyle: {color: '#b8741a'}},
              {name: "50-60天", itemStyle: {color: '#7b4d12'}},
            ],
            top: '65%',
            left: '5%',
            selectedMode: false,
          },
          {
            data: [
              {name: "30天内", itemStyle: {color: '#caf982'}},
              {name: "30-40天", itemStyle: {color: '#95f204'}},
              {name: "40-50天", itemStyle: {color: '#70b603'}},
              {name: "50-60天", itemStyle: {color: '#4b7902'}},
            ],
            top: '65%',
            left: '37%',
            selectedMode: false,
          },
          {
            data: [
              {name: "30天内", itemStyle: {color: '#81d3f8'}},
              {name: "30-40天", itemStyle: {color: '#02a7f0'}},
              {name: "40-50天", itemStyle: {color: '#027db4'}},
              {name: "50-60天", itemStyle: {color: '#015478'}},
            ],
            top: '65%',
            left: '69%',
            selectedMode: false,
          },
        ],
        series: [
          {
            type: 'pie',
            radius: 100,
            center: ['18%', '40%'],
            itemStyle: {
              color: ({name}) => {
                switch (name) {
                  case "50-60天":
                    return '#7b4d12'
                  case "40-50天":
                    return '#b8741a'
                  case "30-40天":
                    return '#f59a23'
                  case "30天内":
                    return '#facd91'
                  default:
                    break;
                }
              },
            },
            label: {formatter: '{b}\n{c}个'},
            data: pieData.startPie,
          },
          {
            type: 'pie',
            radius: 100,
            center: ['50%', '40%'],
            itemStyle: {
              color: ({name}) => {
                switch (name) {
                  case "50-60天":
                    return '#4b7902'
                  case "40-50天":
                    return '#70b603'
                  case "30-40天":
                    return '#95f204'
                  case "30天内":
                    return '#caf982'
                  default:
                    break;
                }
              },
            },
            label: {formatter: '{b}\n{c}个'},
            data: pieData.deliverPie,
          },
          {
            type: 'pie',
            radius: 100,
            center: ['80%', '40%'],
            itemStyle: {
              color: ({name}) => {
                switch (name) {
                  case "50-60天":
                    return '#015478'
                  case "40-50天":
                    return '#027db4'
                  case "30-40天":
                    return '#02a7f0'
                  case "30天内":
                    return '#81d3f8'
                  default:
                    break;
                }
              },
            },
            label: {formatter: '{b}\n{c}个'},
            data: pieData.costPie,
          }
        ]
      })
    })
  }).finally(() => {
    MI_identify.value = false
  })
}



return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "流水冲销授权-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "searchContent searchBg",
              model: _unref(parmasObj),
              "label-width": "auto",
              inline: true,
              ref_key: "searchEle",
              ref: searchEle,
              "label-position": "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "团队:",
                  prop: "orgId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "formItem",
                      modelValue: _unref(parmasObj).orgId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(parmasObj).orgId) = $event)),
                      placeholder: "请选择团队",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysOrganizations, (org) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: org.name,
                            value: org.id,
                            key: org.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "销售:",
                  prop: "salesperson"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(parmasObj).salesperson,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(parmasObj).salesperson) = $event)),
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "请输入以搜索销售",
                      loading: loading.value,
                      "remote-method": remoteSalemanSearch
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(salemanOption.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户ID:",
                  prop: "customerId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(parmasObj).customerId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(parmasObj).customerId) = $event)),
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "请输入以搜索客户ID",
                      loading: idLoading.value,
                      "remote-method": remoteIdSearch
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(idOptions.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户名称:",
                  prop: "customerName"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(parmasObj).customerName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(parmasObj).customerName) = $event)),
                      filterable: "",
                      remote: "",
                      "reserve-keyword": "",
                      placeholder: "请输入以搜索客户名称",
                      loading: nameLoading.value,
                      "remote-method": remoteNameSearch
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nameOptions.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item,
                            label: item,
                            value: item
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(fetchData)(_unref(parmasObj))))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (searchEle.value.resetFields()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default", {
      seleRows: _unref(seleRows),
      callbackFn: () => _unref(fetchData)(_unref(MI_params))
    }),
    _createVNode(_component_el_button, {
      onClick: _cache[6] || (_cache[6] = ($event: any) => (showChart()))
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode(_component_el_table, {
      "cell-style": cellStyleHandle,
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: _cache[7] || (_cache[7] = (row) => _isRef(seleRows) //@ts-ignore
 ? seleRows.value = row : seleRows = row),
      class: "mt-10",
      "max-height": _unref(MI_height) - 70 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "50",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户ID",
          prop: "customerId",
          "show-overflow-tooltip": "",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户名",
          prop: "customerName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "销售",
          prop: "salesperson",
          "show-overflow-tooltip": ""
        }),
        _renderSlot(_ctx.$slots, "column"),
        _createVNode(_component_el_table_column, {
          label: "总销售额",
          prop: "totalAmount",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110",
          sortable: ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "成本",
          prop: "costAmount",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110",
          sortable: ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "利润率",
          prop: "profitRate",
          align: "right",
          sortable: "",
          width: "100"
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("span", null, _toDisplayString(row.profitRate) + "%", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "客户首次下单时间",
          prop: "firstTime",
          formatter: _unref(formatTime),
          width: "145"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "末次下单时间",
          prop: "lastTime",
          formatter: _unref(formatTime),
          width: "145"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "平均回款天数(从创建到关单)",
          prop: "averageDateDiff",
          width: "140",
          align: "right",
          sortable: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单个数",
          prop: "orderNumber",
          align: "right",
          sortable: ""
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("span", null, _toDisplayString(row.orderNumber.toLocaleString()), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "已收款个数",
          prop: "receivedNumber",
          align: "right",
          sortable: ""
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("span", null, _toDisplayString(row.receivedNumber.toLocaleString()), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "已收金额",
          prop: "receivedAmount",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "未收款个数",
          prop: "uncollectedNumber",
          align: "right",
          sortable: ""
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("span", null, _toDisplayString(row.uncollectedNumber.toLocaleString()), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "未收金额",
          prop: "uncollectedAmount",
          align: "right",
          formatter: _unref(formatNumber),
          width: "110"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "未提交个数",
          prop: "notSubmittedNumber",
          align: "right",
          sortable: ""
        }, {
          default: _withCtx(({row}) => [
            _createElementVNode("span", null, _toDisplayString(row.notSubmittedNumber.toLocaleString()), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "未提交金额",
          prop: "notSubmittedAmount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "坏账个数",
          prop: "badNumber",
          align: "right",
          sortable: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "坏账金额",
          prop: "badAmount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"])
      ]),
      _: 3
    }, 8, ["data", "max-height"]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [10, 30, 50, 100, 500],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "历史回款周期分布图",
      modelValue: isShowChart.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isShowChart).value = $event)),
      width: "1350px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          ref_key: "historyChartEle",
          ref: historyChartEle,
          style: {"width":"100%","height":"600px"}
        }, null, 512)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ])), [
    [_directive_loading, _unref(MI_identify)]
  ])
}
}

})